<template>
  <vs-prompt
    @accept="accept"
    @cancel="cancel"
    @close="close"
    :active.sync="showPrompt"
    :title="title"
    :color="color"
    :is-valid="isValid"
    :buttons-hidden="buttonsHidden"
    :button-accept="buttonAccept"
    :button-cancel="buttonCancel"
    :accept-text="acceptText"
    :cancel-text="cancelText"
    :icon-pack="iconPack">
    <slot />
    {{ text }}
  </vs-prompt>
</template>

<script>
export default {
  data() {
    return {
      showPrompt: false
    }
  },
  name: "vx-prompt",
  props: {
    text: {
      default: null,
      type: String
    },
    title: {
      type: String,
      default: "Dialog"
    },
    color: {
      type: String,
      default: "primary",
    },
    isValid: {
      type: [Boolean, String],
      default: 'none'
    },
    buttonsHidden: {
      type: Boolean,
      default: false
    },
    buttonAccept: {
      type: String,
      default: "filled",
    },
    buttonCancel: {
      type: String,
      default: "flat"
    },
    acceptText: {
      type: String,
      default: "Aceitar"
    },
    cancelText: {
      type: String,
      default: "Cancelar"
    },
    iconPack: {
      type: String,
      default: "material-icons"
    }
  },
  methods: {
    togglePrompt(state) {
      if (typeof state == "boolean") this.showPrompt = state
      else this.showPrompt = this.showPrompt ? false : true
    },
    accept(parameters) {
      this.$emit('accept', parameters)
    },
    cancel() {
      this.$emit('cancel')
    },
    close() {
      this.$emit('close')
    },
  }
}

</script>
